import { useQuery } from '@tanstack/react-query'
import { CommentEntityType } from '@omnea-app/comments/commentsFrontendClient'
import { CommentResponse, CommentsHttpClient } from '@omnea-app/comments/commentsHttpClient'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { throwIfApiError } from 'utils/error-handling/throwifApiError'

export const entityCommentsQueryKey = 'entityComments'

type Input = {
  entityId: string
  entity: CommentEntityType
}

export type ListEntityCommentsResponse = CommentResponse<'/entity/{entity}/{entityId}', 'get'>

export function useListEntityComments({ entityId, entity }: Input) {
  const { getToken } = useAuthenticatedUser()

  return useQuery<ListEntityCommentsResponse['data'], ListEntityCommentsResponse['error']>({
    queryKey: [entityCommentsQueryKey, entity, entityId],
    queryFn: async () => {
      const apiClient = new CommentsHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/entity/{entity}/{entityId}', {
        params: {
          path: {
            entity,
            entityId,
          },
        },
      })
      throwIfApiError(error)
      return data
    },
  })
}
